var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"企业上报"}},[_c(_vm.componentShow,{tag:"components"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }